module.exports = __webpack_public_path__ + "img/icn_benefit3.0a21d57e.svg";